import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { GlobalFunctions } from '@global/GlobalFunctions';

/** ApplicationConfiguration */
export class ApplicationSettings {


	ApplicationConfigurationUID: string;
	Application: string;
	Environment: string;
	Config: ApplicationConfiguration;

	constructor(settings?: any) {

		this.Config = new ApplicationConfiguration(
			settings?.Config
		);

		this.ApplicationConfigurationUID = settings?.ApplicationConfigurationUID;
		this.Application = settings?.Application;
		this.Environment = settings?.Environment;

	}
}

/** ApplicationConfiguration */
export class ApplicationConfiguration {

	maintenance: MaintenanceConfiguration;
	deployment: DeploymentConfiguration;

	constructor(configuration?: Partial<ApplicationConfiguration>) {

		this.maintenance =
			new MaintenanceConfiguration(configuration?.maintenance);

		this.deployment =
			new DeploymentConfiguration(configuration?.deployment);
	}
}

/** MaintenanceConfiguration */
export class MaintenanceConfiguration {

	enabled = false;
	message = 'PRISMPdM is undergoing scheduled maintenance.ff';
	start: number | null = null;
	end: number | null = null;

	constructor(configuration?: Partial<MaintenanceConfiguration>) {
		Object.assign(this, configuration);
	}
}

/** DeploymentConfiguration */
export class DeploymentConfiguration {

	silent = true;

	constructor(configuration?: Partial<DeploymentConfiguration>) {
		Object.assign(this, configuration);
	}
}

/**
 * configFilter
 */
export interface IConfigFilter {
	application: string,
	environment: string
}

/** ApplicationService */
@Injectable({
	providedIn: 'root'
})
export class ApplicationService {

	/** apiRoot */
	private apiRoot = "api/application";

	/**
	   * Default Constructor
	   * @param http Imports the 'HttpClient' Object for internet requests
	   * @param HTTPFunctionHelper HTTP Function Helper
	   * @param siteSubscriptions site Subscriptions
	   */
	constructor(
		private http: HttpClient,
		private globalFunctions: GlobalFunctions
	) { }

	/**
	  * Get Application Configuration Settings
	  * @returns Observable<any>
	  */
	getSettings$(filter: IConfigFilter): Observable<any> {

		let data = {}
		let url = this.apiRoot + '/settings'

		const params = new URLSearchParams({
			application: filter.application,
			environment: filter.environment
		});

		url = `${environment.apiUrl}/${url}?${params.toString()}`;

		return this.globalFunctions.fetchAPI(this.http, url, "GET", data);
	}

	/**
	  * Patch Application Settings
	  * @param settingUID 
	  * @param settings
	  * @returns Observable<any>
	  */
	patchSettings$(settingUID: string, settings: any): Observable<any> {

		let data = JSON.stringify(settings);
		let url = this.apiRoot + `/settings/${settingUID}`
		url = `${environment.apiUrl}/${url}`;

		return this.globalFunctions.fetchAPI(this.http, url, "PATCH", data);
	}

}
